import React from "react";
import { Link } from "react-router-dom";

export default function UserIsNotPublisher() {
  return (
    <>
      <p>شما کاربر نمایش دهنده نیستید </p>
      <Link className="btn btn-danger" to="/logout">
        خروج
      </Link>
    </>
  );
}
